module.exports = __webpack_public_path__ + "6156d8f96310d1612fd1042b11071b4b.jpg";